module.exports = __webpack_public_path__ + "static/media/fruit.ccf8bb57.jpg";